import { useSelector } from 'react-redux';

import { PaymentLandingPage } from 'views/payments/';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider, Slide } from '@mui/material';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';

import { QueryClient, QueryClientProvider } from 'react-query';

import { SnackbarProvider } from 'notistack';

// permissions
import { PermissionProvider } from 'context/permissionContext';

import { UserProvider } from 'context/userContext';

import { setLicenseKey } from '@grapecity/wijmo';

// paypal
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

const queryClient = new QueryClient();

// ==============================|| APP ||============================== //

const App = () => {
    const customization = useSelector((state) => state.customization);

    console.log('window', window);
    const data = window.localStorage.getItem('CONFIG');
    window.CONFIG = JSON.parse(data);

    console.log(window.CONFIG);
    setLicenseKey(window.CONFIG.WIJMO_LICENSE_KEY);

    const initialOptions = {
        'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID,
        currency: 'USD',
        intent: 'capture',
        components: 'buttons,marks,funding-eligibility'
    };
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left'
                    }}
                    TransitionComponent={Slide}
                >
                    <QueryClientProvider client={queryClient}>
                        <CssBaseline />
                        <NavigationScroll>
                            <UserProvider>
                                <PermissionProvider>
                                    <Routes />
                                </PermissionProvider>
                            </UserProvider>
                        </NavigationScroll>
                    </QueryClientProvider>
                </SnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
